export const ZoneRow = ({
  zone,
  editValues,
  handleInputChange,
  handleSave,
  isSaving,
}) => {
  const currentValue =
    editValues[zone._id] !== undefined
      ? editValues[zone._id]
      : zone.zoneDescription || "";

  return (
    <div className="zones-management-form__row">
      <div className="zones-management-form__col-name">{zone.name}</div>

      <div className="zones-management-form__col-input">
        <textarea
          className="zones-management-form__textarea"
          rows="2"
          placeholder="Añade una descripción para esta zona..."
          value={currentValue}
          onChange={(e) => handleInputChange(zone._id, e.target.value)}
        />
      </div>

      <div className="zones-management-form__col-actions">
        <button
          onClick={() => handleSave(zone._id)}
          disabled={isSaving === zone._id}
          className="zones-management-form__button"
        >
          {isSaving === zone._id ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </div>
  );
};
